import { useRef, useState } from "react";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import Back from "./Back";

export default function ContainerForgotPWCode({ email, onBack, onContinue }) {
  const logoSrc = document.documentElement.classList.contains("dark")
    ? LogoWhite10
    : LogoBlue;
  const [inputNums, setInputNums] = useState(["", "", "", "", "", ""]);
  const [codeInvalid, setCodeInvalid] = useState(false);
  const inputRefs = useRef([]);

  const handlePaste = (event, startIndex) => {
    event.preventDefault();
    const digits = (event.clipboardData?.getData("text") ?? "")
      .replace(/[^0-9]/g, "")
      .slice(0, inputNums.length - startIndex);

    if (!digits) {
      return;
    }

    const updated = [...inputNums];
    digits.split("").forEach((digit, offset) => {
      updated[startIndex + offset] = digit;
    });
    setInputNums(updated);
    setCodeInvalid(false);
    inputRefs.current[Math.min(startIndex + digits.length, 5)]?.focus();
  };

  const handleDigitChange = (event, index) => {
    const digit = event.target.value.replace(/[^0-9]/g, "").slice(-1);
    const updated = [...inputNums];
    updated[index] = digit;
    setInputNums(updated);
    setCodeInvalid(false);
    if (digit) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const verificationCode = inputNums.join("");
    if (verificationCode.length !== 6) {
      setCodeInvalid(true);
      return;
    }
    onContinue(verificationCode);
  };

  return (
    <div className="w-full max-w-md bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5 m-4 gap-7 flex flex-col border border-zi-blue-light">
      <div className="flex flex-col gap-2 justify-center items-center">
        <img src={logoSrc} alt="لوگو" className="w-14" />
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            کد یک‌بار مصرف را وارد کنید
          </h1>
          <Back onClick={onBack} />
        </div>
        <span className="text-xs font-light text-zi-text-light/50 dark:text-zi-text-dark/50">
          کدی که به ایمیل {email} ارسال شده را وارد کنید.
        </span>
      </div>
      <form className="flex flex-col gap-7" onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4 items-end">
          <div className="flex justify-between items-center gap-4 [direction:ltr]">
            {inputNums.map((digit, index) => (
              <input
                key={index}
                ref={(element) => {
                  inputRefs.current[index] = element;
                }}
                type="text"
                value={digit}
                maxLength="1"
                aria-label={`رقم ${index + 1} کد یک‌بار مصرف`}
                inputMode="numeric"
                pattern="[0-9]*"
                className="size-full aspect-square rounded-lg caret-zi-blue-light border border-zi-border-light dark:border-zi-border-dark bg-zi-bg2-light dark:bg-zi-bg2-dark hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark text-center text-xl font-medium text-zi-text-light dark:text-zi-text-dark outline-none hocus:ring-1 hocus:ring-zi-border-light hocus:dark:ring-zi-border-dark [direction:ltr]"
                onChange={(event) => handleDigitChange(event, index)}
                onPaste={(event) => handlePaste(event, index)}
                onKeyDown={(event) => {
                  if (event.key === "Backspace" && !digit) {
                    inputRefs.current[index - 1]?.focus();
                  }
                  if (event.key === "ArrowLeft") {
                    event.preventDefault();
                    inputRefs.current[index - 1]?.focus();
                  }
                  if (event.key === "ArrowRight") {
                    event.preventDefault();
                    inputRefs.current[index + 1]?.focus();
                  }
                }}
              />
            ))}
          </div>
          <button
            type="button"
            className="text-zi-blue-light text-xs hocus:underline flex items-center gap-1"
          >
            <span>ارسال مجدد کد</span>
            <span>
              (<span>۶۰</span> ثانیه)
            </span>
          </button>
        </div>
        {codeInvalid && (
          <p className="text-red-500 text-sm">لطفا کد شش رقمی را وارد کنید</p>
        )}
        <GradientBlue type="submit" value="ثبت" />
      </form>
    </div>
  );
}
